import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { PlayGameComponent } from './play-game/play-game.component';
import { CreateGameComponent } from './create-game/create-game.component';

const routes: Routes = [
  { path: 'start', component: CreateGameComponent },
  { path: 'game/:gameKey', component: PlayGameComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
